import { Navigate } from "react-router-dom";
import { useAuth } from "@/portal/AuthContext";
import { Loader2 } from "lucide-react";

const FullScreenLoader = () => (
  <div className="min-h-screen bg-[#050505] flex items-center justify-center">
    <Loader2 className="w-8 h-8 text-indigo-400 animate-spin" />
  </div>
);

export const ProtectedRoute = ({ role, children, loginPath = "/prihlaseni" }) => {
  const { user, loading } = useAuth();
  const isStaff = (r) => r === "admin" || r === "assistant" || r === "accountant";

  if (loading) return <FullScreenLoader />;
  if (!user) return <Navigate to={loginPath} replace />;
  const home = isStaff(user.role) ? "/admin" : user.role === "partner" ? "/flotila" : user.role === "worker" ? "/prace" : "/klient";
  if (role === "admin") {
    if (!isStaff(user.role)) return <Navigate to={home} replace />;
  } else if (role === "work") {
    if (!isStaff(user.role) && user.role !== "worker") return <Navigate to={home} replace />;
  } else if (role === "fleet") {
    if (!isStaff(user.role) && user.role !== "partner") return <Navigate to={home} replace />;
  } else if (role && user.role !== role) {
    return <Navigate to={home} replace />;
  }
  return children;
};

export default ProtectedRoute;
